import React from 'react';

export const StartResume = () => (
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
  >
    <path
      d="M60 120.152C93.1371 120.152 120 93.2894 120 60.1523C120 27.0153 93.1371 0.152344 60 0.152344C26.8629 0.152344 0 27.0153 0 60.1523C0 93.2894 26.8629 120.152 60 120.152Z"
      fill="#D8D0FA"
    />
    <mask
      id="mask0_2733_100277"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="120"
      height="121"
    >
      <path
        d="M60 120.152C93.1371 120.152 120 93.2894 120 60.1523C120 27.0153 93.1371 0.152344 60 0.152344C26.8629 0.152344 0 27.0153 0 60.1523C0 93.2894 26.8629 120.152 60 120.152Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_2733_100277)">
      <path
        d="M87.28 28.1523H32.71C26.0825 28.1523 20.71 33.5249 20.71 40.1523V116.152C20.71 122.78 26.0825 128.152 32.71 128.152H87.28C93.9074 128.152 99.28 122.78 99.28 116.152V40.1523C99.28 33.5249 93.9074 28.1523 87.28 28.1523Z"
        fill="white"
      />
    </g>
    <path
      d="M85.5999 35.4922H34.4799C30.7189 35.4922 27.6699 38.5411 27.6699 42.3022V53.3422C27.6699 57.1032 30.7189 60.1522 34.4799 60.1522H85.5999C89.361 60.1522 92.4099 57.1032 92.4099 53.3422V42.3022C92.4099 38.5411 89.361 35.4922 85.5999 35.4922Z"
      fill="#051A49"
    />
    <mask
      id="mask1_2733_100277"
      maskUnits="userSpaceOnUse"
      x="27"
      y="35"
      width="66"
      height="26"
    >
      <path
        d="M85.5999 35.4922H34.4799C30.7189 35.4922 27.6699 38.5411 27.6699 42.3022V53.3422C27.6699 57.1032 30.7189 60.1522 34.4799 60.1522H85.5999C89.361 60.1522 92.4099 57.1032 92.4099 53.3422V42.3022C92.4099 38.5411 89.361 35.4922 85.5999 35.4922Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_2733_100277)">
      <path
        d="M92.41 35.5422V50.9022C83.92 50.9022 77 44.0322 77 35.4922H92.41V35.5522V35.5422Z"
        fill="#E60278"
      />
    </g>
    <path
      d="M65.1499 49.0925V41.0425C69.6099 41.0425 73.2399 44.6425 73.2399 49.1225H65.1499V49.0925Z"
      fill="#0D3880"
    />
    <path
      d="M86.25 60.1525C86.25 55.9225 82.85 52.5225 78.62 52.5225C74.39 52.5225 70.98 55.9225 70.98 60.1525H76.07C76.07 58.7525 77.22 57.6125 78.62 57.6125C80.02 57.6125 81.16 58.7525 81.16 60.1525H86.25Z"
      fill="#E60278"
    />
    <path
      d="M34.2 84.1523H86.62"
      stroke="#DCE5F2"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M34.2 72.1523H86.62"
      stroke="#DCE5F2"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M34.2 96.1523H80.25"
      stroke="#DCE5F2"
      strokeWidth="4"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M112.18 62.5322L111.31 61.6622C108.83 59.1822 104.8 59.1822 102.32 61.6622L99.8901 64.0922L75.8701 88.1122L85.7301 97.9722L109.75 73.9523L110.16 73.5422L112.18 71.5223C114.66 69.0423 114.66 65.0122 112.18 62.5322Z"
      fill="#6E56E6"
    />
    <path
      d="M77.7401 98.7422L85.8701 97.8322L76.0101 87.9722L75.1001 96.1022C74.9301 97.6222 76.2201 98.9122 77.7401 98.7422Z"
      fill="white"
    />
    <mask
      id="mask2_2733_100277"
      maskUnits="userSpaceOnUse"
      x="75"
      y="87"
      width="11"
      height="12"
    >
      <path
        d="M77.7401 98.7422L85.8701 97.8322L76.0101 87.9722L75.1001 96.1022C74.9301 97.6222 76.2201 98.9122 77.7401 98.7422Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_2733_100277)">
      <path
        d="M83.1152 102.124L74.0642 93.0732L68.0326 99.1049L77.0836 108.156L83.1152 102.124Z"
        fill="#0D3880"
      />
    </g>
  </svg>
);
